import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { FormattedMessage, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import * as ApiActions from 'actions/api';
import Availability from 'components/Availability';
import Layout from 'components/Layout';
import Press, { quotes } from 'constants/Press';
import { getFirstLetter, getFirstName } from 'utils/user';
import { serviceInviteStructuredSelector } from 'selectors/invites';
import '../styles/invite-page.scss';
const messages = defineMessages({
    invite: '<strong>{name}</strong> invites you to join <strong>Sweatcoin</strong>{nbsp}— the{nbsp}free app that PAYS you to get fit!',
    titleGift: 'Claim Your 5 Sweatcoins',
    inviteGift: '<strong>{name}</strong> gifts you 5 SWC and invites you to join <strong>Sweatcoin</strong>{nbsp}— the{nbsp}free app that PAYS you to get fit!',
});
class Invite extends Component {
    constructor() {
        super(...arguments);
        this._renderPressEntry = (model, index) => (_jsx(FormattedMessage, Object.assign({}, quotes[model.quoteKey], { children: (quote) => (_jsx("a", { href: model.link, target: "_blank", rel: "noreferrer noopener", className: "invite-page__press__entry", title: quote, children: model.sourceBlack }, `press-entry-${index}`)) }), index));
    }
    static fetchData({ match }, store) {
        return Promise.all([store.dispatch(ApiActions.searchUserByUsername(match.params.username))]);
    }
    render() {
        const { absoluteSharingGiftUrl, config, profile, inviteLink, match } = this.props;
        const storeButtonLink = inviteLink;
        const avatar = get(profile, 'avatar.preview');
        const rewardInvitee = get(profile, 'reward_invitee', false);
        const isGift = config.origin.indexOf('gift.sweatcoinapp.uk') !== -1;
        const name = getFirstName(profile);
        const firstLetter = getFirstLetter(profile);
        return (_jsxs(Layout, { header: false, className: "invite-page", children: [_jsx(FormattedMessage, Object.assign({}, messages.titleGift, { children: (title) => (_jsx(Helmet, Object.assign({}, (isGift ? { title, link: [{ rel: 'image_src', href: absoluteSharingGiftUrl }] } : {}), { meta: [
                            { name: 'event-id', content: 'invite-page' },
                            {
                                name: 'event-params',
                                content: {
                                    username: match.params.username,
                                    inviter_id: profile.id,
                                    channel: this.props.channel,
                                    platform: this.props.platform,
                                },
                            },
                            ...(isGift
                                ? [
                                    { property: 'og:title', content: title },
                                    { property: 'og:image', content: absoluteSharingGiftUrl },
                                    { name: 'twitter:title', content: title },
                                    { name: 'twitter:image', content: absoluteSharingGiftUrl },
                                ]
                                : []),
                        ] }))) })), _jsxs(Layout.Container, { children: [_jsxs("section", { className: "invite-page__content", children: [_jsxs("div", { className: "invite-page__user", children: [_jsxs("div", { className: "invite-page__user__avatar", children: [_jsx("div", { className: "invite-page__user__avatar__pic", style: avatar ? { backgroundImage: `url(${avatar})` } : null }), firstLetter] }), _jsx("div", { className: "invite-page__user__content", children: _jsx("p", { children: _jsx(FormattedMessage, Object.assign({}, (isGift ? messages.inviteGift : messages.invite), { values: { name } })) }) })] }), _jsx(Availability, { className: "invite-page__availability is-column", rewardInvitee: rewardInvitee, storeButtonLink: storeButtonLink, location: this.props.location, from: "InvitePage" })] }), _jsx("div", { className: "invite-page__press", children: Press.map(this._renderPressEntry) })] })] }));
    }
}
Invite.contextTypes = {
    router: PropTypes.object,
};
export default connect(serviceInviteStructuredSelector)(Invite);
